import React from "react";
import styles from "./publicHeader.module.css";
import { FaUser } from "react-icons/fa";

import logo from "./logo.png";
import { Link } from "react-router-dom";

const PublicHeader = () => {
  return (
    <header className={styles.header}>
      <nav className={styles.nav}>
        <Link to="/">
          <figure className={styles.logoFig}>
            <img src={logo} alt="logo" className={styles.logo} />
          </figure>
        </Link>

        <div className={styles.rightSide}>
          <div className={styles.signBlock}>
            <Link to="/login">
              <FaUser className={styles.sign} />
              <p>Sign In</p>
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default PublicHeader;
